<template>
<section class="content">
  <div class="row center-block">
    <div class="box">



      <!-- /.box-header -->
      <div class="box-body">

        <p>URL for QR Code Scanner Login is <a href="https://scanner.visity.io/" target="_blank">{{ scannerUrl }}</a></p>

        <br>
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-outline-primary button" data-toggle="modal" data-target="#exampleModalCenter">
          Add Checkpoint
        </button>


      </div> 

      <div class="loadingContainer" v-if="ShowLoading">
        <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw loading"></i>
      </div>


      <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper" v-if="ShowTable">

        <div class="row box-body">
          <div class="col-sm-12 table-responsive" id="Feedbacks">

            <table aria-describedby="example1_info" role="grid" id="example" style="width:100%" class="display table table-bordered table-striped dataTable wrap">
              <thead>
                <tr role="row">
                  <th></th>
                  <th>Name</th>
                  <th>Mobile (for login)</th>
                  <th>Password</th>
                  <th>Checkpoint</th>
                  <th>Created On</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr class="even" role="row" v-for="(S,index) in List">
                  <td class="sorting_1">{{index+1}}</td>
                  <td class="sorting_1">{{S.name}}</td>
                  <td class="sorting_1">{{S.mobile}}</td>
                  <td class="sorting_1">{{S.password}}</td>
                  <td class="sorting_1">{{ capitalizeFirstLetter(S.checkPoint) }} </td>
                  <td class="sorting_1">{{S.createdOn | formatDate}}</td>
                  <td>
                      <div class="btn-group mr-3" role="group" aria-label="Second group">
                      <button type="submit" class="btn btn-warning " v-on:click="EditModal(S);" data-toggle="modal" data-target="#EditModal">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </button>
                    </div>
                  </td>
                  <td>
                      <div class="btn-group mr-3" role="group" aria-label="Second group">
                      <button type="submit" class="btn btn-danger " v-on:click="Delete(S);">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- /.box-body -->
    </div>

    <!-- Create Modal -->

    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalCenterTitle">Add Checkpoint</h3>
          </div>
          <form v-on:submit.prevent="Add()">
          <div class="modal-body">

              <!-- <div class="form-group">
                <label for="exampleFormControlInput1">Checkpoint *</label>
                <input type="text" v-model="checkPointName" class="form-control" id="exampleFormControlInput1" placeholder required>
              </div> -->

              <div class="form-group">
                <label for="exampleFormControlInput1">Name *</label>
                <input type="text" v-model="name" class="form-control" id="exampleFormControlInput1" placeholder required>
              </div>

              <div class="form-group">
                <label for="exampleFormControlInput1">Mobile (for login) *</label>
                <input type="tel" v-model="mobile" class="form-control" id="exampleFormControlInput1" minlength="10" maxlength="10" placeholder="10 Digit Mobile Number" required>
              </div>

              <div class="form-group">
                <label for="exampleFormControlInput1">Password *</label>
                <input type="text" v-model="password" class="form-control" id="exampleFormControlInput1" required>
              </div>

              <div class="form-group">
                <label for="exampleFormControlInput1">Checkpoint *</label>
                <input type="tel" v-model="checkpoint" class="form-control" id="exampleFormControlInput1" required>
              </div>


          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
            <!-- <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="AddGroup()">Save</button> -->
            <button type="submit" class="btn btn-primary">Save</button>
            <!-- <button type="submit" class="btn btn-primary">Save</button> -->
          </div>
        </form>
        </div>
      </div>
    </div>
    <!-- end of modal -->


    <!-- Start Edit Modal -->

    <div class="modal fade" id="EditModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h3 class="modal-title" id="exampleModalCenterTitle">Edit Checkpoint</h3>
          </div>
          <form v-on:submit.prevent="Edit()">
          <div class="modal-body">

            <!-- <div class="form-group">
                <label for="exampleFormControlInput1">Checkpoint *</label>
                <input type="text" v-model="EditInfo.checkPointName" class="form-control" id="exampleFormControlInput1" placeholder required>
              </div> -->

              <div class="form-group">
                <label for="exampleFormControlInput1">Person Name *</label>
                <input type="text" v-model="EditInfo.name" class="form-control" id="exampleFormControlInput1" placeholder required>
              </div>

              <div class="form-group">
                <label for="exampleFormControlInput1">Mobile *</label>
                <input type="tel" v-model="EditInfo.mobile" class="form-control" id="exampleFormControlInput1" minlength="10" maxlength="10" placeholder="10 Digit Mobile Number" required>
              </div>

              <div class="form-group">
                <label for="exampleFormControlInput1">Password *</label>
                <input type="tel" v-model="EditInfo.password" class="form-control" id="exampleFormControlInput1" placeholder="" required>
              </div>

              <div class="form-group">
                <label for="exampleFormControlInput1">Checkpoint *</label>
                <input type="tel" v-model="EditInfo.checkPoint" class="form-control" id="exampleFormControlInput1" placeholder="" required>
              </div>

          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
            <!-- <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="AddGroup()">Save</button> -->
            <button type="submit" class="btn btn-primary">Save</button>
            <!-- <button type="submit" class="btn btn-primary">Save</button> -->
          </div>
        </form>
        </div>
      </div>
    </div>

    <!-- end of modal -->

  </div>
  </div>
</section>
</template>

<script>

import $ from 'jquery';
import moment from 'moment';
import axios from 'axios';
import {
  globalStore
} from '../../main.js';

import Swal from 'sweetalert2';

// Require needed datatables modules
require('datatables.net')
require('datatables.net-bs')

export default {
  components: {

  },
  data() {
    return {
      List: [],
      Checkpoints: [],
      AccessRights: globalStore.AccessRights,
      eventId: globalStore.eventId,
      clientId: globalStore.clientId,
      url: globalStore.url,
      table: '',
      ShowTable: false,
      ShowLoading: true,
      name: '',
      mobile: '',
      password: '',
      checkpoint: '',
      scannerUrl: '',
      EditInfo: {
        name: '',
        mobile: '',
        password: '',
        checkPoint: ''
      },
    }
  },
  mounted() {

    console.log("Checkpoints Component Loaded...");
    console.log("url: "+globalStore.url);
    console.log("clientId: "+globalStore.clientId);
    console.log("eventId: "+globalStore.eventId);
    console.log("Token: "+globalStore.token)

    this.GetCheckpoints();

  },
  methods: {
    capitalizeFirstLetter(str) {
          if (!str) return ''; // Return empty string if the input is empty
            return str.charAt(0).toUpperCase() + str.slice(1);
    },
    GetCheckpoints(){
      console.log("Get Checkpoints");

      console.log(globalStore.eventId);

      axios.get(
        globalStore.url+ `/api/checkpoints-eventId/`+globalStore.eventId
        ).then(response => {
          console.log("Get All Checkpoints API Response");

          console.log(response)

          this.Checkpoints = response.data;
          this.List = response.data;
          console.log(this.Checkpoints);
          console.log("Total Checkpoints: "+this.Checkpoints.length)
          this.ShowLoading = false;
          this.ShowTable = true;

          this.scannerUrl = this.Checkpoints[0].eventId.customFields.scannerUrl;
          console.log("Scanner URL: "+this.scannerUrl);


          setTimeout(() => {
            this.DisplayTable();
          }, 500);


        }).catch(e => {
          alert(e);
          console.log("Error :"+JSON.stringify(e));
        });


    },
    Add(){

      let payload = {
        // checkPointName: this.checkPointName,
        name: this.name,
        mobile: this.mobile,
        password: this.password,
        checkPoint: this.checkpoint,
        eventId: globalStore.eventId,
        clientId: globalStore.clientId
      }

      console.log('Add Checkpoint Info:', payload);

      // const config = {
      //   headers:{
      //     Authorization: globalStore.token,
      //   }
      // };

      axios.post(globalStore.url + `/api/add-checkpoint`, payload).then((res) => {
        console.log(res)
        location.reload()

        // this.GetCheckpoints();

      }).catch((e) => {
        console.log("error is : " + e);
        swal("Oops!", "Something went wrong. Please contact support!", "error");
      });

    },
    EditModal(info){

      this.EditInfo = {
        checkpointId: info._id,
        name: info.name,
        mobile: info.mobile,
        password: info.password,
        checkPoint: info.checkPoint
      };

      console.log("Info to be Edited: "+JSON.stringify(this.EditInfo));

    },
    Edit(){

      // this.EditInfo.LastUpdated = moment().format();

      console.log("Payload: "+JSON.stringify(this.EditInfo));

      console.log("Checkpoint ID: "+this.EditInfo.checkpointId);

      axios.put(globalStore.url+`/api/edit-checkpoint`, this.EditInfo).then((res) => {
        console.log(res)
        location.reload();

      }).catch((e) => {
        console.log("error is : " + e);
        swal("Oops!", "Something went wrong. Please contact support!", "error");
      })

    },
    Delete(c) {

      let checkpointId = c._id;

      console.log("CheckpointID: "+checkpointId);

      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to undo this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        closeOnConfirm: false,
        closeOnCancel: false
      }).then((result) => {
        if (result.value) {

          axios.put(globalStore.url + `/api/delete-checkpoint`, {checkpointId: checkpointId}).then((res) => {
                  console.log(res);
                  location.reload()
                }).catch(e => {
                  console.log("error" + e);
                  swal("Oops!", "Something went wrong. Please contact support!", "error");
                })

        }
      });

    },
    DisplayTable() {
      setTimeout(() => {
        this.$nextTick(() => {

          let table = $('#example').DataTable({
            // ajax: this.Feedbacks,
            // dom: 'Blfrtip',
            // orderCellsTop: true,
            // ordering:false,
            // fixedHeader: {
            //   // header: true,
            //   footer: true
            // },
            fixedColumns: true,
            autoWidth: true,
            buttons: [{
              extend: 'csvHtml5',
              text: 'Export To Excel',
              title: this.fromDate + ' To ' + this.toDate + ' Feedbacks'
            }]
          });


          // Setup - add a text input to each footer cell
          // $('#example thead tr').clone(true).appendTo('#example thead');
          // $('#example thead tr:eq(1) th').each(function(i) {
          //   var title = $(this).text();
          //   $(this).html('<input type="text" placeholder="Search ' + title + '" />');
          //
          //   $('input', this).on('keyup change', function() {
          //     if (table.column(i).search() !== this.value) {
          //       table
          //         .column(i)
          //         .search(this.value)
          //         .draw();
          //     }
          //   });
          // });
          this.isLoading = false
        })
      }, 100)
    }
  }
}
</script>

<style>


.button{
  width: 10em;
  /* border-radius: 1em; */
}

.button:hover{
  width: 10em;
  /* border-radius: 1em; */
}

.btn-warning,
.btn-danger {
  width: 5em;
}

.btn-outline-danger{
  background-color: #ffffff;
  border: 1px solid red;
  color: red;
}

.btn-outline-danger:focus{
  background-color: red;
  border: 1px solid red;
  color: #ffffff;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.editor {
  /* height: 300px; */
  border-style: solid;
  border-width: 1px;
}

.editormenu {
  border-bottom: 1px solid;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

.buttoncolor {
  color: black;
  background-color: white;
  -webkit-transition-duration: 0.4s; /* Safari */
  transition-duration: 0.4s;
}
.buttoncolor:hover {/* Green */
  background-color: #4CAF50; /* Green */
  color: white;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }

  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.timeline-footer a.btn {
  margin-right: 10px;
}

.modal-title {
  color: #000000;
}

tfoot input {
  width: 10%;
  padding: 3px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// Checkpoints.vue?7f31a65e